export const REGISTRATION_CTX_KEYS = {
  SELF_SERVICE_API: 'self-service-api',
  PROMOHUB: 'promohub',
};

export const REGISTRATION_STORAGE_KEY = {
  CTX: 'initial-landing-point',
  SELF_SERVICE_GREETING: 'self-service-greeting',
};

export const REGISTRATION_URL_PARAM = {
  CTX: 'reg-ctx',
};

export const registration_contexts = [
  REGISTRATION_CTX_KEYS.SELF_SERVICE_API,
  REGISTRATION_CTX_KEYS.PROMOHUB,
];
